import { css } from "emotion";

export const wrapperStylesCSS = css({
  height: "40rem",
  textAlign: "center"
});
